import {mapActions, mapGetters, mapState} from 'vuex';
import schoolWeekMixin from '../../schoolWeekMixin';
import {getCurrentWeek, isBetween} from '../../utilities';
import moment from 'moment';

export default {
    data: () => ({
        roomId: undefined,
        week: new Date()
    }),
    mixins: [schoolWeekMixin],
    computed: {
        ...mapState('timetable', ['timetableOfRoom']),
        ...mapState('setting', ['rooms', 'sys', 'periodsDefs', 'weekRanges']),
        ...mapGetters('setting', ['schoolYear', 'semester']),
        ...mapState(['loading']),

        weeks() {
            return getCurrentWeek(this.now.toDate());
        },
        timePlots() {
            if (this.timetableOfRoom) {
                const keys = Object.keys(this.timetableOfRoom);
                if (keys.length > 0) {
                    return keys.reduce((obj, key) => {
                        const wd = moment(key).weekday();
                        const c = wd === 0 ? 8 : wd === 6 ? 7 : wd;
                        return {
                            ...obj,
                            [c]: this.tryMerge(this.timetableOfRoom[key]
                                .filter(r => r.flag === 0
                                    || r.flag === 1 && !this.isEvenWeek
                                    || r.flag === 2 && this.isEvenWeek
                                ))
                                .map(r => ({
                                    ...r,
                                    isPast: this.isPast(key),
                                    isFuture: this.isFuture(key),
                                    isNow: this.isNow(key)
                                }))
                        }
                    }, {});
                }
            }
            return {};
        },
        pickerOptions() {
            const self = this;
            return {
                firstDayOfWeek: 1,
                disabledDate: date => {
                    return !self.isValidDate(date);
                }
            };
        },
        selectedRoom() {
            return this.rooms.find(r => r.id === this.roomId);
        }

    },
    filters: {
        shortDate(value) {
            return value.format('YYYY-MM-DD dd');
        }
    },
    watch: {
        week(current) {
            if (this.isWeekInRange(current)) {
                this.now = moment(current);
            } else {
                this.week = this.now.toDate();
            }
        }
    },
    methods: {
        tryMerge(plots = []) {
            const sortedPlots = [...plots].sort((a, b) => a.begin - b.begin);
            const len = sortedPlots.length;
            for (let i = 0; i < len - 1; ++i) {

                if(!sortedPlots[i]) continue;

                const nextIdx = i + 1;
                //如果有重疊的話
                if (isBetween(sortedPlots[i].begin, sortedPlots[nextIdx].begin, sortedPlots[nextIdx].end)
                    || isBetween(sortedPlots[i].end, sortedPlots[nextIdx].begin, sortedPlots[nextIdx].end)) {

                    const expandCurrent = [...Array(sortedPlots[i].span).keys()]
                        .map(k => k + sortedPlots[i].begin);
                    const expandNext = [...Array(sortedPlots[nextIdx].span).keys()]
                        .map(k => k + sortedPlots[nextIdx].begin);
                    const newNext = expandNext.filter(p => expandCurrent.indexOf(p) === -1);

                    //如果整個起訖都重疊的話，就不要處理
                    if (newNext.length === 0) {
                        sortedPlots[nextIdx] = null;
                    }
                    else if (newNext.length === 1) {
                        sortedPlots[nextIdx] = {
                            ...sortedPlots[nextIdx],
                            begin: newNext[0],
                            end: newNext[0],
                            span: 1
                        }
                    } else {
                        sortedPlots[nextIdx] = {
                            ...sortedPlots[nextIdx],
                            begin: newNext[0],
                            end: newNext[newNext.length - 1],
                            span: newNext.length
                        }
                    }
                }
            }
            return sortedPlots.filter(s => s);
        },

        isPast(date) {
            return moment(date).isBefore(moment(), 'd');
        },

        isFuture(date) {
            return moment(date).isAfter(moment(), 'd');
        },

        isNow(date) {
            return moment(date).isSame(moment(), 'd')
        },

        isValidDate(date) {
            const {dateBegin, dateEnd} = this.sys;
            return moment(date).isBetween(dateBegin, dateEnd, 'd', '[]');
        },

        isWeekInRange(date) {
            return getCurrentWeek(moment(date).toDate())
                .some(day => this.isValidDate(day));
        },

        async prevWeek() {
            const prev = moment(this.now).subtract(7, 'd');
            if (this.isWeekInRange(prev)) {
                this.now = prev;
                await this.refresh();
            } else {
                this.$message({
                    message: '超過可查詢的範圍',
                    type: 'warning'
                });
            }

        },
        async nextWeek() {
            const next = moment(this.now).add(7, 'd');
            if (this.isWeekInRange(next)) {
                this.now = next;
                await this.refresh();
            } else {
                this.$message({
                    message: '超過可查詢的範圍',
                    type: 'warning'
                });
            }

        },
        async current() {
            const current = moment();
            if (this.isWeekInRange(current)) {
                this.now = current;
                await this.refresh();
            } else {
                this.$message({
                    message: '超過可查詢的範圍',
                    type: 'warning'
                });
            }
        },
        ...mapActions('timetable', {
            getTimetableOfRoom: 'getTimetableOfRoomAction'
        }),
        ...mapActions('setting', {
            getWeekRanges: 'getWeekRangesAction'
        }),

        async refresh() {
            const {schoolYear, semester, weeks, selectedRoom} = this;
            await this.getTimetableOfRoom({
                schoolYear, semester, roomId: selectedRoom.ncutRoomId,
                begin: weeks[0].format('YYYY-MM-DD'),
                end: weeks[6].format('YYYY-MM-DD')
            });
            this.week = weeks[0].toDate();
        },

        async weekChange() {
            if (this.isWeekInRange(this.week)) {
                await this.refresh();
            }
        }
    }
}
